// src/components/MarketStatus.jsx
import React, { useState, useEffect } from "react";

const MarketStatus = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [marketStatus, setMarketStatus] = useState({ isOpen: false, message: '' });

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const checkMarketStatus = () => {
      const now = new Date();
      const day = now.getDay(); // 0 = Sunday, 6 = Saturday
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const currentMinutes = hours * 60 + minutes;

      // Market hours: Monday-Friday, 9:30 AM - 4:00 PM EST
      // Convert to minutes: 9:30 = 570, 16:00 = 960
      const marketOpen = 570; // 9:30 AM
      const marketClose = 960; // 4:00 PM

      // Check if it's a weekday
      const isWeekday = day >= 1 && day <= 5;

      if (!isWeekday) {
        setMarketStatus({
          isOpen: false,
          message: 'Market Closed - Weekend'
        });
      } else if (currentMinutes >= marketOpen && currentMinutes < marketClose) {
        // Calculate time until close
        const minutesUntilClose = marketClose - currentMinutes;
        const hoursUntilClose = Math.floor(minutesUntilClose / 60);
        const minsUntilClose = minutesUntilClose % 60;
        
        setMarketStatus({
          isOpen: true,
          message: `Market Open - Closes in ${hoursUntilClose}h ${minsUntilClose}m`
        });
      } else if (currentMinutes < marketOpen) {
        // Before market opens
        const minutesUntilOpen = marketOpen - currentMinutes;
        const hoursUntilOpen = Math.floor(minutesUntilOpen / 60);
        const minsUntilOpen = minutesUntilOpen % 60;
        
        setMarketStatus({
          isOpen: false,
          message: `Market Closed - Opens in ${hoursUntilOpen}h ${minsUntilOpen}m`
        });
      } else {
        // After market closes
        setMarketStatus({
          isOpen: false,
          message: 'Market Closed - Opens Tomorrow 9:30 AM EST'
        });
      }
    };

    checkMarketStatus();
    const interval = setInterval(checkMarketStatus, 60000); // Update every minute

    return () => clearInterval(interval);
  }, [currentTime]);

  return (
    <div className="flex items-center gap-4 text-sm">
      <div className="flex items-center gap-2">
        <div
          className={`w-2 h-2 rounded-full ${
            marketStatus.isOpen ? 'bg-green-500 animate-pulse' : 'bg-red-500'
          }`}
        ></div>
        <span className={`font-semibold ${
          marketStatus.isOpen 
            ? 'text-green-600 dark:text-green-400' 
            : 'text-red-600 dark:text-red-400'
        }`}>
          {marketStatus.message}
        </span>
      </div>
      <span className="text-gray-500 dark:text-gray-400">
        {currentTime.toLocaleTimeString('en-US', { 
          hour: '2-digit', 
          minute: '2-digit',
          second: '2-digit'
        })}
      </span>
    </div>
  );
};

export default MarketStatus;
